import { useEffect, useState } from 'react';
import type { TooltipState } from '../data/types';

export const useModuleRailTooltip = (rowClass: string, nameClass: string) => {
    const [tooltip, setTooltip] = useState<TooltipState>(null);

    const openTooltip = (text: string, el: HTMLElement) => {
        const rect = el.getBoundingClientRect();
        setTooltip({ text, top: rect.top + rect.height / 2, left: rect.right + 8 });
    };
    const closeTooltip = () => setTooltip(null);

    const openTruncatedLabelTooltip = (inRow: HTMLElement, fullLabel: string) => {
        const row = inRow.closest<HTMLElement>(`.${rowClass}`);
        const name = row?.querySelector(`.${nameClass}`);
        if (!row || !name || name.scrollWidth <= name.clientWidth) return;
        openTooltip(fullLabel, row);
    };

    useEffect(() => {
        if (!tooltip) return;
        window.addEventListener('scroll', closeTooltip, { capture: true });
        window.addEventListener('resize', closeTooltip);
        return () => {
            window.removeEventListener('scroll', closeTooltip, { capture: true });
            window.removeEventListener('resize', closeTooltip);
        };
    }, [tooltip]);

    return { tooltip, openTooltip, closeTooltip, openTruncatedLabelTooltip };
};
